import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { FiSearch } from "react-icons/fi";
import { BsPlusLg,BsDashLg } from "react-icons/bs";
import { BsTelephone } from "react-icons/bs";
import { HiOutlineMail} from "react-icons/hi";
import {tabData} from "../../data/Data"
import { useState } from "react";
const Faqs = () => {
  const [activeAccordian,setActiveAccordian] = useState(0)
  return (
    <section className="faq">
      <div className="container">
        <div className="faq-wrapper">
          <h2>Hello, how can we help?</h2>
          <form className="asking-form">
            <div className="asking-form-input">
              <FiSearch className="asking-form-input-icon" />
              <input type="text" placeholder="Ask a question..." />
            </div>
            <button type="button">Search</button>
          </form>
          <p className="faq-pera">
            Or choose a category to quickly find the help you need
          </p>
          <Tabs>
            <TabList>
              <div className="support">
                {
                  tabData?.tabHeader?.map((header,i)=><Tab key={i} className="support-item">
                  {header?.icon}
                  <span>{header?.heading}</span>
                </Tab>)
                }
              </div>
            </TabList>
          {
            tabData?.tabs?.map((tab,i)=><TabPanel key={i}>
            <div className="accordion">
              <Accordion>
                {
                  tab?.tab?.map((singleTab,i)=><AccordionItem key={i}>
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <div className="question" onClick={()=>setActiveAccordian(singleTab?.uid)}>
                        <div className="question-left">
                          <span className={`dot ${activeAccordian === singleTab?.uid ? "dot-active" : ""}`}></span> {singleTab?.question}
                        </div>
                        <div className="collapse-icon">
                          {
                            activeAccordian === singleTab?.uid ? <BsDashLg /> : <BsPlusLg />
                          }
                        </div>
                      </div>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div className="answer">
                      <div className="answer-content">
                        <p>{singleTab?.answer1}</p>
                        <p>{singleTab?.answer2}</p>
                      </div>
                    </div>
                  </AccordionItemPanel>
                </AccordionItem>)
                }
                
              </Accordion>
            </div>
            </TabPanel>)
          }
            
          </Tabs>
          <div className="contact-options">
            <div className="contact-option">
              <BsTelephone className="contact-option-icon  rotate" />
              <p>+ (880) 1786062901</p>
              <span>We are always happy to help you</span>
            </div>
            <div className="contact-option">
              <HiOutlineMail className="contact-option-icon" />
              <p>support@helpcenter.com</p>
              <span>The best way to get answer faster.</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faqs;
